import { useState, useEffect, useCallback } from 'react';
import { generateClient } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { getUnreadCount as getUnreadCountQuery } from '../graphql/chat';

export function useUnreadCount(leagueId: string) {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCount = useCallback(async () => {
    try {
      setLoading(true);

      const session = await fetchAuthSession();
      if (!session.tokens) {
        console.log('[useUnreadCount] No session tokens, skipping');
        return;
      }

      console.log('[useUnreadCount] Fetching unread count for league:', leagueId);

      // Create client inside the function to ensure Amplify is configured
      const client = generateClient();

      const result: any = await client.graphql({
        query: getUnreadCountQuery,
        variables: { leagueId },
        authMode: 'userPool',
      });

      console.log('[useUnreadCount] GraphQL result:', JSON.stringify(result, null, 2));
      const count = result.data.getUnreadCount || 0;
      console.log('[useUnreadCount] Unread count:', count);
      setUnreadCount(count);
    } catch (err) {
      console.error('[useUnreadCount] Failed to fetch unread count:', err);
      console.error('[useUnreadCount] Error details:', JSON.stringify(err, null, 2));
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  }, [leagueId]);

  // Poll for unread count every 10 seconds
  useEffect(() => {
    fetchUnreadCount();

    const interval = setInterval(() => {
      fetchUnreadCount();
    }, 10000);

    return () => clearInterval(interval);
  }, [fetchUnreadCount]);

  // Reset unread count
  const resetUnreadCount = useCallback(() => {
    setUnreadCount(0);
  }, []);

  return {
    unreadCount,
    loading,
    fetchUnreadCount,
    resetUnreadCount,
  };
}
